import AGREGAR_CATALOGO_EXPEDIENTE_DOCUMENTO from '@/graphql/mutations/administracion/catalogos/expedientes/agregarCatalogoExpedienteDocumento.gql';
import REMOVER_CATALOGO_EXPEDIENTE_DOCUMENTO from '@/graphql/mutations/administracion/catalogos/expedientes/removerCatalogoExpedienteDocumento.gql';
import ACTUALIZAR_CATALOGO_EXPEDIENTE_DOCUMENTO from '@/graphql/mutations/administracion/catalogos/expedientes/actualizarCatalogoExpedienteDocumento.gql';
import CATALOGO_EXPEDIENTE from '@/graphql/querys/administracion/catalogos/expedientes/catalogoExpediente.gql';

export default {
  methods: {
    // Agregar expediente
    async mixAgregarCatalogoExpediente() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_CATALOGO_EXPEDIENTE_DOCUMENTO,
        variables: {
          expedienteDocumento: this.expedienteDocumento,
        },
        update: (store, { data: { agregarCatalogoExpedienteDocumento } }) => {
          const query = {
            query: CATALOGO_EXPEDIENTE,
          };
          const { catalogoExpediente } = store.readQuery(query);
          const catalogoExpedienteDocumentoCopia = catalogoExpediente.slice();
          catalogoExpedienteDocumentoCopia.push(agregarCatalogoExpedienteDocumento);
          store.writeQuery({
            ...query,
            data: {
              catalogoExpediente: catalogoExpedienteDocumentoCopia,
            },
          });
        },
      })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Actualizar expediente
    async mixActualizarCatalogoExpediente() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CATALOGO_EXPEDIENTE_DOCUMENTO,
        variables: {
          id: this.expedienteEditar.id,
          expedienteDocumento: this.expedienteDocumento,
        },
        update: (store, { data: { actualizarCatalogoExpedienteDocumento } }) => {
          const query = {
            query: CATALOGO_EXPEDIENTE,
          };
          const data = store.readQuery(query);
          const { catalogoExpediente } = data;
          const index = catalogoExpediente
            .findIndex((expediente) => expediente.id
            === actualizarCatalogoExpedienteDocumento.id);
          if (index !== -1) {
            catalogoExpediente.splice(index, 1, actualizarCatalogoExpedienteDocumento);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar expediente
    async mixEliminarCatalogoExpediente() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CATALOGO_EXPEDIENTE_DOCUMENTO,
        variables: {
          id: this.expedienteEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({
            query: CATALOGO_EXPEDIENTE,
          });
          const { catalogoExpediente } = data;
          const index = catalogoExpediente
            .findIndex((expediente) => expediente.id === this.expedienteEliminar.id);
          if (index !== -1) {
            catalogoExpediente.splice(index, 1);
          }
          store.writeQuery({ query: CATALOGO_EXPEDIENTE, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },

};
